// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_IbZ","cls2":"common-cls2_T8j common-cls1_IbZ"};